<div class="downloading">
    <img src="../../../assets/images/backgrounds/download.gif" alt="">
</div>
